import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "A VeloClin atende médicos de qualquer estado do Brasil?",
    a: "Sim! A VeloClin é uma plataforma 100% em nuvem, com validade jurídica e de prescrição (via Memed) em todo o território nacional. Atendemos médicos de qualquer cidade do país.",
  },
  {
    q: "Quanto tempo demora para migrar meus dados do sistema antigo?",
    a: "A migração é assistida pela nossa equipe e leva em média 48 horas. Importamos pacientes, agenda e histórico financeiro sem que você precise parar o atendimento.",
  },
  {
    q: "O sistema é seguro e atende às normas da LGPD e CFM?",
    a: "Sim. Todos os dados trafegam com criptografia SSL, o armazenamento segue a LGPD e as receitas usam assinatura digital compatível com as normas do CFM.",
  },
  {
    q: "Preciso instalar algo ou contratar TI?",
    a: "Não. O VeloClin é 100% na nuvem e funciona em qualquer navegador ou tablet. Sem instalação, sem servidor, sem equipe de TI.",
  },
  {
    q: "O Copiloto de WhatsApp usa meu número oficial?",
    a: "Sim, conectamos ao número oficial da sua clínica via API oficial do WhatsApp, mantendo a comunicação profissional e centralizada.",
  },
  {
    q: "Existe alguma taxa sobre as consultas que eu recebo?",
    a: "A VeloClin não cobra comissão sobre suas consultas. Existe apenas uma taxa fixa de R$10,50 por pagamento realizado, devido aos custos operacionais de emissão de cobranças, descontada somente após o pagamento do paciente. Cobranças não pagas não geram custo.",
  },
  {
    q: "Posso cancelar quando quiser?",
    a: "Claro. Não há fidelidade nos planos mensais. Você pode exportar seus dados e cancelar a qualquer momento pelo próprio painel.",
  },
];

export const Faq = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="mx-auto max-w-[820px] px-5 md:px-8">
        <div className="mb-10 text-center">
          <p className="text-xs font-semibold uppercase tracking-wider text-blue-600">Dúvidas</p>
          <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Perguntas frequentes
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="overflow-hidden rounded-2xl border border-slate-200/70 bg-white px-5 shadow-[0_2px_8px_rgba(0,0,0,0.03)]"
            >
              <AccordionTrigger className="py-4 text-left text-sm font-semibold text-slate-900 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-4 text-sm leading-relaxed text-slate-600">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
